import React from 'react';

import FormatNumbers from '../../../../utils/formatNumbers';


export const FooterQuoterMicMovil = (props) => {

    const {
        setFooterOpen, footerOpen, optionsTotal, total_tax, viewQuoter,
        formQuoterMic, handleChangeTypeClient, setActiveIndex,
        setHideTabs, hasDeterminations, handleViewQuoter, handleClosedQuoter
    
    } = props;
    

    return (

        <div className="d-block d-md-none">
            {/* FOOTER MOVIL */}
            <div
                className="footer-hamburger-mobile"
                onClick={() => setFooterOpen(prev => !prev)}
            >
                <i className={`fa ${footerOpen ? "fa-times" : "fa-dollar"}`}></i>
            </div>

            <div className={`footer-wrapper-mobile ${footerOpen ? "open" : ""}`}>
                <div className="footer-mobile-panel">

                    <div className="mobile-stats-row">

                        <div className="mobile-stat-card">
                            <span>SUBTOTAL</span>
                            <strong>
                                ${FormatNumbers(optionsTotal.subtotal, 2)}
                            </strong>
                        </div>

                        <div className="mobile-stat-card">
                            <span>IVA ({total_tax}%)</span>
                            <strong>
                                ${FormatNumbers(optionsTotal.tax, 2)}
                            </strong>
                        </div>

                    </div>

                    <div className="mobile-total-card">
                        <span>TOTAL</span>

                        <strong>
                            ${FormatNumbers(optionsTotal.total, 2)}
                        </strong>
                    </div>

                    {/* Acctions */}
                    <div className="mobile-actions-row">

                        {!viewQuoter &&
                            formQuoterMic.id_quatation !== null &&
                            formQuoterMic.valid_sampling && (

                                <button
                                    className="mobile-btn-secondary"
                                    onClick={() => {
                                        handleChangeTypeClient(4);

                                        if (setActiveIndex) setActiveIndex(0);
                                        if (setHideTabs) setHideTabs(false);
                                    }}
                                >
                                    <i className="fa fa-plus-circle"></i>
                                    Nueva
                                </button>
                            )
                        }

                        <button
                            className="mobile-btn-primary"
                            onClick={viewQuoter ? handleClosedQuoter : handleViewQuoter}
                            disabled={!hasDeterminations}
                        >
                            <i className="fa fa-eye"></i>

                            {viewQuoter
                                ? "Cerrar"
                                : "Previsualizar"}
                        </button>

                    </div>

                </div>
            </div>
        </div>

    )
}
